import {Localizer} from "../../../infrastructure/localization/localizer";

export enum DashboardAmountEnum {
    Nul = 1,
    EnTilTo = 2,
    TreTilFire = 3,
    FemTilSeks = 4,
    SyvTilTi = 5,
    OverTi = 6
}

export class CategoryCounts {
    amountGroupCategory: DashboardAmountEnum;
    groupCategoryName: string;
    count: number;
    onCellClick?: () => void;
}

export const translateDashboardAmountEnum = (value: DashboardAmountEnum): string => {
    switch (value) {
        case DashboardAmountEnum.Nul:
            return Localizer.dashboard_nul();
        case DashboardAmountEnum.EnTilTo:
            return Localizer.dashboard_enTilto();
        case DashboardAmountEnum.TreTilFire:
            return Localizer.dashboard_treTilFire();
        case DashboardAmountEnum.FemTilSeks:
            return Localizer.dashboard_femTilSeks();
        case DashboardAmountEnum.SyvTilTi:
            return Localizer.dashboard_syvTilTi();
        case DashboardAmountEnum.OverTi:
            return Localizer.dashboard_overTi();
        default:
            return "Unknown";
    }
}
